<div class="container custom-container">
  <div class="row">
    <div class="col-auto p-0">
      <app-sidenav></app-sidenav>
    </div>
    <div class="col p-0">
      <div class="p-0 mt-0" style="background-color: #ffff ;width: 100%;height: 100%;">
        <app-header></app-header>
        <div class="main-block">
          <div class="d-flex justify-content-between align-items-start wrap-block create-col">
            <div class="mt-2">
              <div class="split-button" style="display:flex;gap:8px">
                <button type="button" class="btn btn-secondary btn-sm new-btn" style="background-color: #5D3C6C;"
                  (click)="onOpenSupportInsert()">
                  <img src="assets/img/plus.png" class="btn-img" /> New Technician
                </button>

              </div>

            </div>
            <div class="mt-2 wrap-block forms-search" style="display: flex; align-items: center; margin-right: 20px;">

              <div class="search-form-field searchType-input">
                <mat-form-field>
                  <input matInput (keyup)="applyFilter($event)" [(ngModel)]="searchKey" placeholder="Type to Search" />
                </mat-form-field>
                <!-- <mat-icon class="searchIcon" style="cursor: pointer;"
                                (click)="applyFilterIcon()">search</mat-icon> -->
              </div>
            </div>
          </div>
          <div class="mat-elevation-z8 member-table table-container" style="margin-bottom: 60px">
            <table mat-table [dataSource]="dataSource">

              <ng-container matColumnDef="firstName">
                <th class="mat-table-header" mat-header-cell *matHeaderCellDef>
                  FirstName
                </th>
                <td mat-cell *matCellDef="let row">{{ row.firstName }}</td>
              </ng-container>

              <ng-container matColumnDef="lastName">
                <th class="mat-table-header" mat-header-cell *matHeaderCellDef>
                  Last Name
                </th>
                <td mat-cell *matCellDef="let row" style="width:17%; word-break: break-all;">{{ row.lastName }}</td>
              </ng-container>



              <ng-container matColumnDef="email">
                <th class="mat-table-header" mat-header-cell *matHeaderCellDef>
                  Email
                </th>
                <td mat-cell *matCellDef="let row">{{ row.email }}</td>
              </ng-container>


              <ng-container matColumnDef="designation">
                <th class="mat-table-header" mat-header-cell *matHeaderCellDef>
                  Designation
                </th>
                <td mat-cell *matCellDef="let row">
                  {{ row.designation }}
                </td>
              </ng-container>
              <ng-container matColumnDef="status">
                <th class="mat-table-header" mat-header-cell *matHeaderCellDef>
                  Status
                </th>
                <td mat-cell *matCellDef="let row">
                  <span *ngIf="row.isActive==1" class="badge bg-success-subtle text-success">Active</span>
                  <span *ngIf="row.isActive==0" class="badge bg-danger-subtle text-danger">Suspended</span>
                </td>
              </ng-container>
              <ng-container matColumnDef="TypeOfMember">
                <th class="mat-table-header" mat-header-cell *matHeaderCellDef> Type Of Member </th>
                <td mat-cell *matCellDef="let element"><span class="badge" [ngStyle]="{
                              'background-color':'#b3d9ff' ,
                   'color':'#003366'
                 }" *ngIf="element.typeOfMember=='Help Desk Admin'">{{ element.typeOfMember||'N/A'}}</span>
                  <span class="badge" [ngStyle]="{
                              'background-color': '#d7bde2',
                   'color': '#4a235a'
                 }" *ngIf="element.typeOfMember!='Help Desk Admin'">{{
                    element.typeOfMember||'N/A'}}</span>
                </td>
              </ng-container>

              <ng-container matColumnDef="Actions" style="white-space: nowrap;">
                <th class="mat-table-header" mat-header-cell *matHeaderCellDef>
                  Actions
                </th>
                <td mat-cell *matCellDef="let element">
                  <mat-icon color="primary"
                    style="font-size:22px; margin: 5px 2px; position: relative;bottom: -6px;cursor: pointer;"
                    *ngIf="element.typeOfMember!='Help Desk Admin' && element.isActive==1" matTooltip="Set as Help Desk Admin"
                    (click)="changeStatus(element)" >admin_panel_settings</mat-icon>
                  <mat-icon color="primary"
                    style="font-size:22px; margin: 5px 2px; position: relative;bottom: -6px;cursor: pointer;"
                    *ngIf="element.typeOfMember=='Help Desk Admin' && element.isActive==1" matTooltip="Set as Technician Member"
                    (click)="changeStatus(element)">person_remove</mat-icon>
                  <!-- Add any action buttons here -->
                  <div class="edit-icon" matTooltip="Edit" style="cursor: pointer;" (click)="onClickUpdate(element)">
                    <img src="assets/img/view.png" />
                  </div>
                  <!-- <div class="activate-icon"  style="cursor: pointer;background-color:#F8D7DA;color: red;" matTooltip="Inactivate" 
                              (click)="suspendUser(element) ">
                              <img src="assets/img/suspend.png" />
                              </div> -->
                  <div class="activate-icon" *ngIf="element.isActive==1"
                    style="cursor: pointer;background-color:#F8D7DA;" matTooltip="Inactivate"
                    (click)="suspendUser(element) ">
                    <img src="assets/img/suspend.png" />
                  </div>

                  <div class="suspend-icon" *ngIf="element.isActive==0" matTooltip="Activate"
                    style="cursor: pointer; background-color:#D1E7DD;" (click)="activateUser(element)">
                    <img src="assets/img/activate.png" />

                  </div>
                  <!-- <mat-icon matTooltip="Delete" style="cursor: pointer;"
                              (click)="deleteSharePoint(row.id)" class="delete-icon">delete</mat-icon> -->
                  <div class="delete-icon" matTooltip="Delete" style="cursor: pointer;"
                    (click)="onDeleteSubmit(element)">
                    <img src="assets/img/delete.png">
                  </div>

                </td>
              </ng-container>

              <ng-container matColumnDef="Category/Sub Category">
                <th class="mat-table-header" mat-header-cell *matHeaderCellDef>
                  Category / Sub category
                </th>
                <td mat-cell *matCellDef="let row">
                  <span *ngIf="row.parentCategoryId!=0"> {{row.parentCategoryName }} </span>
                  <span *ngIf="row.parentCategoryId==0"> {{'N/A' }} </span>
                  <span *ngIf="row.subCategoryId!=0"> / {{row.subCategoryName}}</span><span
                    *ngIf="row.subCategoryId==0"> / {{'N/A'}}</span>
                </td>
              </ng-container>

              <!-- <ng-container matNoDataRow *ngIf="this.users?.length === 0;">
                            <td colspan="12">No data to display</td>
                          </ng-container> -->

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
            <!-- <div *ngIf="this.users?.length == 0" style="text-align: center;padding: 50px;background-color: white;">
                          <p>no records found </p>
                        </div> -->
            <mat-paginator [pageSizeOptions]="[ 10, 25, 100]" showFirstLastButtons [length]="users.length"
              [(pageSize)]="PageSize" [(pageIndex)]="pageNo" class="metaPaginate">
            </mat-paginator>
            <!-- <mat-paginator [pageSizeOptions]="[10, 25, 100]" showFirstLastButtons length="300"></mat-paginator>
                        <mat-paginator [pageSizeOptions]="[10, 25, 100]" showFirstLastButtons [length]="totalItems" [(pageSize)]="pageSize"
                          [(pageIndex)]="currentPage" (page)="onPaginatorClick($event)" class="metaPaginate">
                        </mat-paginator> -->
            <!-- <nav class="navbar fixed-bottom footer-bar d-flex justify-content-center">
                          <div>Member Connect</div>
                        </nav> -->

          </div>
          <div class="modal fade" id="newSupportCreate" data-backdrop="static" tabindex="-1" role="dialog"
            aria-labelledby="staticBackdropLabel" aria-hidden="true">
            <div class="modal-dialog">
              <div class="modal-content">
                <!-- Modal Header -->
                <div class="modal-header">
                  <h4 class="modal-title">{{heading}}</h4>
                  <button type="button" class="close" data-dismiss="modal" (click)="hide()">
                    <mat-icon class="inactive-icon" style="color: red; font-size: 27px;">cancel</mat-icon>
                  </button>
                </div>

                <!-- Modal Body -->
                <div class="modal-body">
                  <div class="container">
                    <form [formGroup]="supportform"
                      (ngSubmit)="this.submitControl? SupportFormSubmit() : SupportFormUpdateSubmit()">
                      <!-- First Name -->
                      <div class="form-group mb-3">
                        <label for="firstName">First Name <span style="color: red;">*</span></label>
                        <input type="text" class="form-control signup-input" id="firstName" placeholder="First Name"
                          formControlName="firstName" />
                        <div *ngIf="supporSubmitted && supportControl.firstName.errors" class="text-danger ml-2">
                          <div *ngIf="supportControl.firstName.errors.required">First Name is required</div>
                          <div *ngIf="supportControl.firstName.errors.pattern">Avoid special characters. Minimum 3
                            characters required.</div>
                        </div>
                      </div>

                      <!-- Last Name -->
                      <div class="form-group mb-3">
                        <label for="lastName">Last Name <span style="color: red;">*</span></label>
                        <input type="text" class="form-control signup-input" id="lastName" placeholder="Last Name"
                          formControlName="lastName" />
                        <div *ngIf="supporSubmitted && supportControl.lastName.errors" class="text-danger ml-2">
                          <div *ngIf="supportControl.lastName.errors.required">Last Name is required</div>
                          <div *ngIf="supportControl.lastName.errors.pattern">Avoid special characters. Minimum 1
                            character required.</div>
                        </div>
                      </div>

                      <!-- Email -->
                      <div class="form-group mb-3" *ngIf="this.submitControl">
                        <label for="email">Email <span style="color: red;">*</span></label>
                        <input type="email" class="form-control signup-input" id="email" placeholder="Email"
                          formControlName="email" />
                        <div *ngIf="supporSubmitted && supportControl.email.errors" class="text-danger ml-2">
                          <div *ngIf="supportControl.email.errors.required">Email is required</div>
                          <div *ngIf="supportControl.email.errors.pattern">Enter a valid email address</div>
                        </div>
                      </div>
                      <div class="form-group mb-3">
                        <label for="lastName">Designation <span style="color: red;">*</span></label>
                        <input type="text" class="form-control signup-input" id="lastName" placeholder="designation"
                          formControlName="designation" />
                        <div *ngIf="supporSubmitted && supportControl.designation.errors" class="text-danger ml-2">
                          <div *ngIf="supportControl.designation.errors.required">Designation is required</div>
                          <div *ngIf="supportControl.designation.errors.pattern">Avoid special characters. Minimum 1
                            character required.</div>
                        </div>
                      </div>
                      <div class="form-group ">
                        <label for="roleType">Catagory </label><span style="color: red;"> *</span>
                        <select class="form-control" formControlName="parentCategoryId" id="roleType"
                          placeholder="roleType" style="
                                                            padding-left: 15px;" (change)="oncatogorySelect($event)">
                          <option value=0>Select Catogory</option>
                          <!-- <option value="">Select State</option> -->
                          <option *ngFor="let role of this.catagoryDropDown" value="{{role.categoryId}}">
                            {{role.categoryName}}</option>
                        </select>

                      </div>
                      <div class="form-group " *ngIf="isPresent">
                        <label for="roleType">Sub Catagory <span style="color: red;"> *</span></label>
                        <select class="form-control" formControlName="subCategoryId" id="roleType"
                          placeholder="roleType" style="
                                                            padding-left: 15px;">
                          <option value=0>Select Sub Catogory</option>
                          <!-- <option value="">Select State</option> -->
                          <option *ngFor="let role of  this.subCatagoryDropDown" value="{{role.categoryId}}">
                            {{role.categoryName}}</option>
                        </select>

                      </div>


                      <!-- Group ID -->
                      <!-- <div class="form-group mb-3">
                                    <label for="groupId"> Vendor Group <span style="color: red;">*</span></label>
                                    <select class="form-control" id="groupId" formControlName="groupId">
                                      <option value="" disabled selected>Select Group</option>
                                      <option *ngFor="let group of groupList" [value]="group.id">{{ group.name }}</option>
                                    </select>
                                    <div *ngIf="supporSubmitted && supportControl.groupId.errors" class="text-danger ml-2">
                                      <div *ngIf="supportControl.groupId.errors.required">Group ID is required</div>
                                    </div>
                                  </div> -->

                      <!-- Submit and Cancel Buttons -->
                      <div class="footer-modal" style="display: flex; justify-content: flex-end;">
                        <button class="sync-btn" type="submit" [disabled]="!checkAllFieldsEntered()">
                          <span>{{footer}} </span>
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal fade" id="suspendModel" data-backdrop="static" tabindex="-1" role="dialog"
            aria-labelledby="staticBackdropLabel" aria-hidden="true">
            <div class="modal-dialog">
              <div class="modal-dialog">
                <div class="modal-content">
                  <!-- Modal Header -->
                  <div class="modal-header">
                    <h4 class="modal-title">{{formheading}}</h4>
                    <button type="button" class="close" data-dismiss="modal" (click)="SuspendHide()">
                      <!-- <img src="assets/img/modal-close.png" /> -->
                      <mat-icon class="inactive-icon" style="color: red;font-size: 27px;">cancel</mat-icon>
                    </button>
                  </div>
                  <div class="form-group mb-3" style="padding-left: 20px;padding-right: 20px; margin:5px">
                    <label>Reason <span style="color: red;">*</span></label>
                    <form>
                      <textarea [(ngModel)]="textvalue" placeholder="Reason" name="remarks" class="textarea"
                        style="width: 100%; height:120px;border: 1px solid grey; padding: 10px;  transition: border 0.3s ease;"></textarea>
                    </form>
                    <div *ngIf="isEmpty() && isusersubmitted" class="text-danger">Please Enter Valid Reason</div>
                  </div>
                  <div class="button suspend-footer" style="padding: 20px">
                    <button class="sync-btn" type="submit" [disabled]="isEmpty()"
                      (click)="visible ? SuspendMemberSubmit() : activeMemberSubmit()">
                      <span>Submit</span>
                    </button>
                  </div>
                  <!-- <div class="space" style="margin: 10px;"></div> -->
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>
<ngx-spinner bdColor="rgba(0, 0, 0, .6)" class="spin-img" template="<img src='assets/img/logo-D.gif' />">
</ngx-spinner>